/**
 * Epg page implementation.
 *
 * @author Stoian Roman <stoyan.roman@gmail.com>
 */

'use strict';

/* eslint max-lines-per-function: 0 */

var Page = require('stb-component-page'),
    // page = new Page({$node: document.getElementById('pageEpg')}),
    // app = require('mag-app'),

    tag = require('spa-dom').tag,
    keys = require('stb-keys'),

    Footer = require('mag-component-footer'),

    ModalMessage = require('mag-component-modal'),
    LayoutList = require('mag-component-layout-list'),
    Layout = require('mag-component-layout'),
    Scroll = require('stb-component-scrollbar'),

    EpgGrid = require('./epg.grid'),

    footer, actionModal, actionList,
    headerLayout, contentLayout,
    epgGrid,
    scroll,
    ICONS;

if ( TARGET === 'android-app' || TARGET === 'android-stb' ) {
    ICONS = {
        realtime: 'theme-icon theme-icon-back',
        record: 'theme-icon theme-icon-play'
    };
} else {
    ICONS = {
        realtime: 'theme-icon theme-icon-rc-f3',
        record: 'theme-icon theme-icon-rc-f1'
    };
}


function prepareChannels ( data ) {
    var list = [],
        items = [],
        channel, schedule, censored,
        index, $logo;

    for ( index = 0; index < data.length; index++ ) {
        $logo = tag('div', {className: 'logo'});
        if ( data[index].logo ) {
            $logo.style.backgroundImage = 'url(' + core.backend.host + data[index].logo + ')';
        }

        censored = data[index].censored || (data[index].genre && data[index].genre.censored);
        items = [
            {
                className: 'number',
                value: data[index].number.toString()
            },
            $logo,
            {
                className: 'name',
                value: data[index].name
            },
            {
                className: data[index].archive ? 'theme-icon theme-icon-timeshift disabled' : 'theme-icon hidden'
            },
            {
                className: censored ? 'theme-icon theme-icon-lock disabled' : 'theme-icon hidden'
            },
            {
                className: 'arrowLeft theme-epg-grid-arrow-left'
            },
            {
                className: 'arrowRight theme-epg-grid-arrow-right'
            },
            {
                className: 'theme-epg-grid-timeshift hidden'
            }
        ];

        channel = new Layout({
            focusable: false,
            data: items,
            className: 'channel theme-epg-grid-main',
            events: {
                click: function () {
                    this.parent.emit('click');
                }
            }
        });

        schedule = new Layout({
            focusable: false,
            className: 'schedule',
            data: [],
            events: {
                click: function () {
                    this.parent.emit('click');
                }
            }
        });

        channel.listIndex = index;
        schedule.listIndex = index;

        list.push({
            value: data[index],
            items: [channel, schedule],
            censored: censored
        });
    }

    return list;
}


/**
 * Send intent ro record epg program
 */
function sendRecordEpgIntent () {
    var channel = epgGrid.$focusItem.data.value,
        epg;

    if ( epgGrid.epgLastFocused ) {
        epg = epgGrid.epgLastFocused.data;
    }

    core.intent({
        action: 'record',
        data: {
            uri: channel.url,
            name: channel.name,
            epgName: channel.name,
            startTime: epg ? epg.start : epgGrid.time,
            endTime: epg ? epg.end : epgGrid.time + epgGrid.timeStep,
            id: channel.id,
            pvr: {
                server: channel.pvr,
                local:  channel.local_pvr
            }
        }
    }, function ( ) { /**/ });
}


/**
 * Epg page implementation.
 *
 * @constructor
 * @extends stb-component-page
 *
 * @param {Object} [config={}] - init parameters (all inherited from the parent)
 * @param {Object} config.apiProvider - api provider to get Epg
 *
 * Epg item click event.
 *
 * @event epg:click
 *
 * @type {Object}
 * @property {number} channelIndex focus channel index
 * @property {Object} epg focus epg item data
 *
 * Channel item click event.
 *
 * @event channel:click
 *
 * @type {Object}
 * @property {number} channelIndex focus channel index
 *
 * Click back button event.
 *
 * @event back
 *
 * @type {Element} focus item
 */
function EpgPage ( config ) {
    var self = this;

    config.className = 'magcore-page-epg' + (config.className ? ' ' + config.className : '');
    Page.call(this, config);

    this.addListener('show', function ( event ) {
        epgGrid.focusIndex(event.data.index);
        epgGrid.focus();
        epgGrid.startCheck();
    });

    this.addListener('keydown', function ( event ) {
        switch ( event.code ) {
            case keys.back:
                epgGrid.stopCheck();
                self.emit('back', epgGrid.$focusItem);
                break;
        }
    });

    headerLayout = new Layout({
        focusable: false,
        data: [
            {
                name: '$title',
                className: 'title',
                value: gettext('TV Guide')
            },
            {
                name: '$current',
                className: 'current'
            },
            {
                name: '$description',
                className: 'description'
            }
        ],
        className: 'header-layout theme-epg-grid-main'
    });
    this.add(headerLayout);

    contentLayout = new Layout({
        focusable: false,
        data: [
            {
                className: 'time'
            },
            {
                name: '$timeline',
                className: 'timeline theme-epg-grid-timeline'
            }
        ],
        className: 'content'
    });
    this.add(contentLayout);

    epgGrid = new EpgGrid({
        className: 'epg-list',
        size: require('./metrics').epgGrid,
        events: {
            'click:item': function ( event ) {
                var item = event.$item;

                if ( item.data.value.epgItems.length ) {
                    if ( item.data.value.epgItems[item.data.value.epgFocus] ) {
                        if ( item.data.value.archive && item.data.value.epgItems[item.data.value.epgFocus].data.archive ) {
                            self.emit('epg:click', {channelIndex: item.index, epg: item.data.value.epgItems[item.data.value.epgFocus].data});
                        } else {
                            self.emit('channel:click', {channelIndex: item.index});
                        }
                    }
                } else {
                    self.emit('channel:click', {channelIndex: item.index});
                }
            },
            'focus:item': function ( data ) {
                var item = data.$curr,
                    list = [];

                data = {
                    left: {},
                    middle: [],
                    label: {
                        code: keys.menu,
                        title: gettext('Hold OK button to open Options menu'),
                        action: function () {
                            actionModal.show();
                            actionModal.focus();
                        }
                    }
                };

                if ( item.data.value.pvr || item.data.value.local_pvr ) {
                    data.middle.push({
                        code: keys.f1,
                        title: gettext('Record'),
                        action: sendRecordEpgIntent
                    });

                    list.push({
                        items: [
                            {
                                className: ICONS.record
                            },
                            {
                                className: 'title',
                                value: gettext('Record')
                            }
                        ],
                        click: function () {
                            actionModal.hide();
                            sendRecordEpgIntent();
                        }
                    });
                }

                list.push({
                    items: [
                        {
                            className: ICONS.realtime
                        },
                        {
                            className: 'title',
                            value: gettext('To real time')
                        }
                    ],
                    click: function () {
                        actionModal.hide();
                        epgGrid.goToRealTime();
                    }
                });

                data.middle.push({
                    code: keys.f3,
                    title: gettext('To real time'),
                    action: function () {
                        epgGrid.goToRealTime();
                    }
                });
                data.left = {
                    code: keys.menu,
                    action: function () {
                        actionModal.show();
                        actionModal.focus();
                    }
                };
                footer.init(data);
                actionList.init({
                    data: list,
                    size: list.length,
                    focusIndex: 0
                });
            }
        },
        noData: gettext('No Channels'),
        apiProvider: config.apiProvider,
        focusIndex: 0,
        scroll: scroll = new Scroll(),
        //epg config
        $timeBlock: contentLayout.$node.children[0],
        $programDescription: headerLayout.links.$description,
        $programName: headerLayout.links.$current,
        $timeLine: contentLayout.links.$timeline
    });

    contentLayout.add(epgGrid);
    contentLayout.add(scroll);

    if ( DEVELOP ) {
        window.epgGrid = epgGrid;
    }

    footer = new Footer({visible: false, parent: this});
    footer.init({
        left: {
            code: keys.menu,
            action: function () {
                actionModal.show();
                actionModal.focus();
            }
        },
        middle: [
            {
                code: keys.f1,
                title: gettext('Record'),
                action: sendRecordEpgIntent
            },
            {
                code: keys.f3,
                title: gettext('To real time'),
                action: function () {
                    epgGrid.goToRealTime();
                }
            }
        ],
        label: {
            code: keys.menu,
            title: gettext('Hold OK button to open Options menu'),
            action: function () {
                actionModal.show();
                actionModal.focus();
            }
        }
    });
    footer.show();

    this.add(
        actionModal = new ModalMessage({
            title: gettext('Actions'),
            className: 'width2x',
            events: {
                show: function () {
                    footer.hide();
                    this.children[0].focus();
                },
                hide: function () {
                    footer.show();
                    epgGrid.focus();
                }
            },
            children: [
                actionList = new LayoutList({
                    size: 2,
                    focusIndex: 0,
                    cycle: true,
                    data: [
                        {
                            items: [
                                {
                                    className: ICONS.record
                                },
                                {
                                    className: 'title',
                                    value: gettext('Record')
                                }
                            ],
                            click: function () {
                                actionModal.hide();
                                sendRecordEpgIntent();
                            }
                        },
                        {
                            items: [
                                {
                                    className: ICONS.realtime
                                },
                                {
                                    className: 'title',
                                    value: gettext('To real time')
                                }
                            ],
                            click: function () {
                                actionModal.hide();
                                epgGrid.goToRealTime();
                            }
                        }
                    ],
                    events: {
                        keydown: function ( event ) {
                            LayoutList.prototype.defaultEvents.keydown.call(this, event);
                            switch ( event.code ) {
                                case keys.menu:
                                case keys.back:
                                    actionModal.hide();
                                    event.stop = true;
                                    break;
                            }
                        }
                    }
                })
            ]
        })
    );
}


EpgPage.prototype = Object.create(Page.prototype);
EpgPage.prototype.constructor = EpgPage;


/**
 * Set channel list.
 *
 * @param {Array} data - channels
 */
EpgPage.prototype.setChannels = function ( data ) {
    epgGrid.setData({
        data: prepareChannels(data),
        focusIndex: 0
    });
    epgGrid.updateEpg();
};


module.exports = EpgPage;
